<div class="custom-slider" [class.multiple]="multiple">
  <swiper-container
    #swiper
    *ngIf="images"
    atlSwiper
    [config]="swiperconfig"
    [slides]="images"
    init="false"
    class="swiper-container"
    [class.multiple]="multiple"
    (afterInitSwiper)="afterInitSwiper.emit($event)"
  >
    <ng-container *ngFor="let slide of images; let i = index; trackBy: trackBy">
      <swiper-slide class="custom-slider d-flex flex-column align-items-center w-100" [class.multiple]="multiple">
        <div class="image-wrapper" [class.multiple]="multiple" (click)="emitPreview(i)">
          <img
            [src]="getImageUrl(slide, displayW500Image)"
            alt="image"
            class="custom-slider__slide"
            [class.multiple]="multiple"
          />
        </div>
      </swiper-slide>
    </ng-container>
  </swiper-container>

  <ng-container *ngIf="multiple">
    <ng-content select="footer"></ng-content>
  </ng-container>
</div>
